import { gql } from '@apollo/client';

const OTB_ELIGIBLITY = gql`
  query OTBEligibility($accountId: String!, $customerId: String!) {
    account(accountId: $accountId, customerId: $customerId) {
      id
      checkEligibility(eligibilityType: OTB_RELEASE) {
        eligibility {
          eligible
        }
      }
    }
  }
`;

export { OTB_ELIGIBLITY };
